import axios from 'axios'
import Config from "@/components/Config.vue";
export async function read(fileGuid,fileName){
	if(!fileName){
		return this.$message.error('获取文件名失败')
	}
	let url = await readUrl(fileGuid,fileName)
	if(url){
		window.open(url)
	}
}

export async function readUrl(fileGuid,fileName){
	let suffix = fileName
  if(fileName.indexOf('.')>-1){
    let names = fileName.split('.')
    suffix = names[names.length-1]
  }
  suffix = suffix.toLowerCase()
  if(['zip','7z','war','rar'].indexOf(suffix)>-1){
    return Vue.message.error('此类型文件不支持预览')
  }
  if(['mp4','aac','mp3','wav','m4a','ogg'].indexOf(suffix)>-1){
    return Config.appUrl+'/audit/videoPlayer?guid='+fileGuid
  }
	let res = await axios.get('/api/store/v1/3rd/file/getReadLink?guid='+fileGuid)
	return res.data
}
export async function edit(fileGuid,fileName){
  window.open(await editUrl(fileGuid,fileName))
}
export async function editUrl(fileGuid,fileName){
	let res = await axios.get('/api/store/v1/3rd/file/getEditLink?guid='+fileGuid)
	return res.data
}
export function down(fileGuid,fileName,noFileCallBack){
  downSourceFile(fileGuid,fileName)
}
export function deleteFile(fileGuid){
}
export function downSourceFile(guid, fileName){
	axios
	.post("/api/store/v0.1/download", "tenant=portal&guid=" + guid, {
		responseType: "blob"
	})
	.then(res => {
		if (res.status == 200) {
			let url = window.URL.createObjectURL(new Blob([res.data]));
			let link = document.createElement("a");
			link.style.display = "none";
			link.href = url;
			link.setAttribute("download", fileName); // 自定义下载文件名（如exemple.txt）
			document.body.appendChild(link);
			link.click();
		}
	});
}